export const EventPreviewBackground = ({
    className,
}: {
    className: string
}) => (
    <svg viewBox="0 0 562 193" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_b_64_7363)">
            <path
                d="M0 24.5C0 11.2452 10.7452 0.5 24 0.5H218.537C224.848 0.5 231.017 2.3658 236.27 5.86277L253.206 17.1372C258.459 20.6342 264.628 22.5 270.939 22.5H280.99H291.167C297.795 22.5 304.26 20.4417 309.668 16.6094L324.089 6.39057C329.497 2.5583 335.962 0.5 342.591 0.5H538C551.255 0.5 562 11.2452 562 24.5V168.5C562 181.755 551.255 192.5 538 192.5H24C10.7452 192.5 0 181.755 0 168.5V24.5Z"
                fill="#19AEB7"
                fillOpacity="0.25"
            />
        </g>
        <defs>
            <filter
                id="filter0_b_64_7363"
                x="-30"
                y="-29.5"
                width="622"
                height="252"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="15" />
                <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_64_7363"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_64_7363"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
)
